import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast,Modal } from "react-bootstrap";
// import { Row, Col, Button, Form, Tabs, Tab, Toast, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Loader from "./../../../components/Loader";
import {_HttpServices} from './../../../_services/_HttpServices';
import {IoIosClose,IoMdDoneAll} from "react-icons/io";
import moment from 'moment';
import { Footer } from "../../../components/Footer";
const TrackTrance = () => {
  const fileName = "DataSync";
  const [dataSyncDisable, setDataSyncDisable] = useState();
  const [loading, setLoading] = useState(false);
  const [showToaster , setShowToaster] = useState(false);
  const [lastDataSyncTime , setLastDataSyncTime] = useState();
  useEffect(()=>{
    setInterval(()=>{
      if(!localStorage.getItem('dataSync')){
        setDataSyncDisable(false);
      }else{
        setDataSyncDisable(true);
      }
    }, 10000)
    getLastDataSyncTime();
    if(!localStorage.getItem('dataSync')){
      setDataSyncDisable(false);
    }else{
      setDataSyncDisable(true);
    }
  },[])
  const getLastDataSyncTime = () => {
      setLoading(true)
    _HttpServices.getData(`api/inbound/LastDataSyncTime`)
      .then(res => {
        res.data = moment(res.data).format('MM/DD/YYYY HH:mm:ss'); 
        setLastDataSyncTime(res.data);
        setLoading(false)
      })
      .catch(error =>{
        setLoading(false)
      })
  }
  const syncData = () => {
    setShowToaster(false)    
    setDataSyncDisable(true);
    localStorage.setItem('dataSync', true);
    setLoading(true)
    _HttpServices.postData(`Api/services/DataSync`)
      .then(rep => {
        setLoading(false)   
        setShowToaster(false)    
        getLastDataSyncTime();
        if(!localStorage.getItem('dataSync')){
          setDataSyncDisable(false);
          localStorage.removeItem("products");
          localStorage.removeItem("contacts");
          localStorage.removeItem("barColors");
          localStorage.removeItem("barLabels");
          localStorage.removeItem("clients");
          localStorage.removeItem('dataSync');
        }        
      })
      .catch(error =>{
        setLoading(false)
      })
  }

  const syncDataConfirmation = () => {
    setShowToaster(true);
  }
  const cancel = () => {
    setDataSyncDisable(false)
    setShowToaster(false)
  }
  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Data Sync</h2>
        <div className="ml-2">
          {
            lastDataSyncTime && lastDataSyncTime !== '' ?
            <label><h5>Last Data Sync Time :  {lastDataSyncTime} </h5></label>
            : ''
          }
        </div>
        {loading ? <Loader /> : null}
      </div>
      <Modal show={showToaster}
          onHide={() => setShowToaster(false)}
          backdrop="static"
          keyboard={false} >
          <Modal.Header closeButton>
              <Modal.Title>
                  <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                  <strong>Are you sure to Data Sync?</strong>
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              {/* <p className="ml-2">Are you sure to Data Sync? </p> */}
              <p className="ml-2"> <strong>Note:</strong> Data Sync may take few minutes.</p>
          </Modal.Body>
          <Modal.Footer>
              <div className="text-right mt-2">
                  <Button
                      onClick={() => syncData()}
                  >
                      <IoMdDoneAll className="icon btn-icon" />Yes</Button>
                  <Button
                      variant="danger"
                      className="ml-3 btn-sm"
                      onClick={() => cancel(false)}
                  >
                      <IoIosClose className="icon btn-icon" />No</Button>
              </div>
          </Modal.Footer>
      </Modal>
      <Row>
        <Col md={12}>
          <div className="card pt-2">
            <div className="card-body">
              <div className="inventory-grid">
                <Fragment>
                    <div className="mb-3">
                        <h5 style={{textDecorationLine: 'underline'}}>End Points</h5>
                    </div>
                    <div>
                        <ul className="list">
                            <li>Contacts</li>
                            <li>Inventory Transaction</li>
                            <li>Invoices</li>
                            <li>Products</li>
                            <li>Purchase Order</li>
                            <li>Goods Receipts</li>
                            <li>Sales Order</li>
                            <li>Shipments</li>
                        </ul>
                    </div>
                    {dataSyncDisable ? 
                      <div className="text-right mb-3">
                        <Button onClick={syncDataConfirmation} disabled={dataSyncDisable}>Data Sync In progress </Button>
                      </div> 
                      :
                      <div className="text-right mb-3">
                        <Button onClick={syncDataConfirmation} disabled={dataSyncDisable}>Sync Data</Button>
                    </div>
                    }
                </Fragment>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Footer />
    </section>
  );
};
export default TrackTrance;
